import { ChatList } from "./chat-list";

type Props = {
  onClose?: () => void;
};

/**
 * チャット履歴一覧カード
 */
export function ChatListCard({ onClose }: Props) {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <div className="flex min-h-0 flex-1 flex-col px-0 py-0">
        <ChatList onClose={onClose} />
      </div>
    </div>
  );
}
